interface EnhanceWindow extends Window {
  _digy: any[];
  _hmt: any[];
}

declare const window: EnhanceWindow;

/**
  描述：包含百度打点的打点通用方法
  参数：
 * @param topkey        - (Str) 三段式打点，topkey
 * @param subkey        - (Str) 三段式打点，subkey
 * @param value         - (Str) 三段式打点，value
  */
const digyAndHm = (category: string, action: string, optLabel: string, optValue: string): void => {
  window._hmt && window._hmt.push(['_trackEvent', category, action, optLabel, optValue]);
  window._digy && window._digy.push(category + ',' + action + ',' + optLabel + (optValue || ''));
};

export default digyAndHm;
